import { render, staticRenderFns } from "./FormTitle.vue?vue&type=template&id=3bb50492&scoped=true&"
import script from "./FormTitle.vue?vue&type=script&lang=js&"
export * from "./FormTitle.vue?vue&type=script&lang=js&"
import style0 from "./FormTitle.vue?vue&type=style&index=0&id=3bb50492&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb50492",
  null
  
)

export default component.exports